import { TYPE } from '@/constants';

import { Shape } from './shape';

export default class Rect extends Shape {
  constructor(params) {
    super(params);
    this.initView();
    this.render();
  }

  initView() {
    const { radius, position, width, height, rotation } = this.attributes;
    const [cx, cy] = position;
    this.shape = this.canvas.rect(width, height).radius(radius);
    this.shape.center(cx, cy);
    this.view.add(this.shape);
    this.view.addClass(`shape-${this.subtype}`);
    this.view.transform({ rotation });
  }

  get subtype() {
    return TYPE.RECT;
  }

  get radius() {
    return this.attributes.radius;
  }

  set radius(value) {
    this.setAttribute('radius', value);
    this.shape.radius(value);
  }

  get width() {
    return this.attributes.width;
  }

  set width(value) {
    this.setAttribute('width', value);
    this.shape.width(value);
  }

  get height() {
    return this.attributes.height;
  }

  set height(value) {
    this.setAttribute('height', value);
    this.shape.height(value);
  }

  toJSON() {
    const { uuid, type, subtype, sid } = this;
    const { cx, cy } = this.rbox();
    const rotation = this.view.transform('rotation');
    const attributes = Object.assign({}, this.attributes, {
      position: [cx, cy],
      rotation,
    });
    return Rect.filteredJSON({
      uuid,
      sid,
      type,
      subtype,
      attributes,
    });
  }

  static fromJSON(params) {
    return Rect.create(params);
  }

  static create(params) {
    const attributes = {
      position: [0, 0],
      rotation: 0,
      radius: 5,
      width: 50,
      height: 50,
      styles: {},
    };
    params.attributes = Object.assign({}, attributes, params.attributes);
    return new Rect(params);
  }
}
